
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[articleType]/[slug]",
      function () {
        return require("private-next-pages/[articleType]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[articleType]/[slug]"])
      });
    }
  